module.exports = __webpack_public_path__ + "media/flags/ws-55ccdcf0.svg";